import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import DTQuestionOrInstructionView from '../../DTQuestionOrInstructionView';
import Question from '../../Common/Question/Question';
import {
  getSimplrAccountIdOfSelectedTicket,
  getDecisionTreeCouponCodeTypes,
  getSelectedCouponCodeType,
} from '../../../../../../extractFromState';
import { trackDecisionNodeQuestionAnswered } from '../../../../../../analytics/searchEventAnalytics';
import { loadCouponCodeTypes } from '../../../../../../actions/couponCodeActions';
import { addEdgeToDecisionTreePath, setSelectedCouponCodeType } from '../../../../../../actions/searchActions';
import { DecisionTreeButton } from '../../../../../common/buttonsComponents';

const DTSelectCouponCodeNode = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const couponCodeTypes = useSelector(getDecisionTreeCouponCodeTypes);
  const selectedCouponCodeType = useSelector(getSelectedCouponCodeType);

  const handleSelectCouponType = useCallback(
    (couponType) => {
      trackDecisionNodeQuestionAnswered(couponType?.name);
      dispatch(setSelectedCouponCodeType(couponType));
      dispatch(addEdgeToDecisionTreePath('type_selected'));
    },
    [dispatch]
  );

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await dispatch(loadCouponCodeTypes(simplrAccountId));
      setIsLoading(false);
    })();
  }, [setIsLoading, simplrAccountId, dispatch]);

  useEffect(() => {
    // if there is only one type, auto-select
    if (!isEmpty(couponCodeTypes) && couponCodeTypes.length === 1 && !selectedCouponCodeType) {
      handleSelectCouponType(couponCodeTypes[0]);
    }
  }, [handleSelectCouponType, couponCodeTypes, selectedCouponCodeType]);

  const renderOptions = () => {
    if (isEmpty(couponCodeTypes)) {
      return null;
    }

    return couponCodeTypes.map((couponType) => (
      <DecisionTreeButton key={couponType.name} onClick={() => handleSelectCouponType(couponType)}>
        {couponType.name}
      </DecisionTreeButton>
    ));
  };

  return <DTQuestionOrInstructionView titleSection={<Question />} options={renderOptions()} loading={isLoading} />;
};

export default DTSelectCouponCodeNode;
